import { FE_PREFETCH_PDP_APIS_TOUCH_250415 } from "@faire/retailer-settings/FE_PREFETCH_PDP_APIS_TOUCH_250415";
import {
    useAssignSetting,
    useSetting,
  } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingPDPPrefetchOnTouch = (): boolean =>
  useSetting(FE_PREFETCH_PDP_APIS_TOUCH_250415);

export const useAssignSettingPDPPrefetchOnTouch = () =>
  useAssignSetting(FE_PREFETCH_PDP_APIS_TOUCH_250415);
